import { ActivityType, ArticleChangeImportance, BasicActionPlanTopic, SegmentReport, SimpleActionPlanTopic, SurveyActionPlanTopic, SurveySegment } from '.';

//... and the ActionPlanTypes array
export const ActionPlanTypes = ['WPA', 'Independent', 'Article'] as const;
export type ActionPlanType = typeof ActionPlanTypes[number];

export type ActionPlanOwner =
    { type: 'MemberUser', userId: string, fullName: string } |
    { type: 'RegularUser', userId: string, fullName: string };


type CommonActionPlan = {
    id: string,
    activityId: string,
    activityType:ActivityType,
    activityTitle: string,
    start:Date,
    end:Date,
    title:string,
    description: string,
    type: ActionPlanType,
    owner: ActionPlanOwner | null
}

type IndependentActionPlanTypeData = { 
    type: 'Independent' 
};
type ArticleActionPlanTypeData = { 
    type: 'Article', 
    customData:{ 
        articleId:string 
    } 
};
type WorkplaceAssessmentActionPlanTypeData = { 
    type: 'WPA', 
    customData:{ 
        segmentFilter: SurveySegment[][] 
    } 
};

// Update the ActionPlanTypeData type to add new types
// CustomData contents is serialized to JSON in the DB
export type ActionPlanTypeData =
    IndependentActionPlanTypeData |
    ArticleActionPlanTypeData |
    WorkplaceAssessmentActionPlanTypeData;

// This is used for reading data from the DB where we don't need the full ActionPlanView
export type SimpleActionPlanView = 
    CommonActionPlan & 
    ActionPlanTypeData &
    {
        topics:SimpleActionPlanTopic[]
    };

export type SurveyActionPlanView = 
    CommonActionPlan & 
    WorkplaceAssessmentActionPlanTypeData &
    {
        topics:(SurveyActionPlanTopic | BasicActionPlanTopic)[],
        surveyData: {
            surveyAnswerCount: number,
            segmentReport: SegmentReport[]
        }
    };

export type IndependentActionPlanView =
    CommonActionPlan & 
    IndependentActionPlanTypeData &
    {
        topics:BasicActionPlanTopic[]
    };

export type ArticleActionPlanView =
    CommonActionPlan & 
    ArticleActionPlanTypeData &
    {
        topics:BasicActionPlanTopic[]
        articleData:{
            title: string,
            description: string,
            reference: string,
            list: {
                id: string,
                name: string,
            };
            topic: {
                id: string,
                name: string;
            },
            date: Date | null,
            url: string,
            owner: {
                userId:string,
                displayName:string,
                initials:string
            } | null,
            importance:ArticleChangeImportance
        }
    };

export type ActionPlanView = SurveyActionPlanView | IndependentActionPlanView | ArticleActionPlanView;


